'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _jsxFileName = 'src/base-components/contact-icon.js';
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
var _icon = require('@marmalade/icon');
var _icon2 = _interopRequireDefault(_icon);
var _themes = require('@marmalade/themes');
var _withHeaderTheme = require('../hocs/with-header-theme');
var _withHeaderTheme2 = _interopRequireDefault(_withHeaderTheme);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var headerStyle = _themes.componentThemes.header.headerStyle;
ContactIcon.propTypes = {
  type: _propTypes.string.isRequired,
  theme: _propTypes.object.isRequired
};
function ContactIcon(_ref) {
  var type = _ref.type,
    theme = _ref.theme;
  return _react2.default.createElement(_icon2.default, {
    type: type,
    css: {
      color: theme[headerStyle('colorIcon')],
      paddingRight: theme.space_xs,
      fontSize: '32px',
      verticalAlign: 'middle'
    },
    __source: {
      fileName: _jsxFileName,
      lineNumber: 16
    },
    __self: this
  });
}
exports.default = (0, _withHeaderTheme2.default)(ContactIcon);